<template>
  <div class="from_box flex">
    <div class="item">
      <!-- :propertyObject="headerData" inputProperty="purchaseOrderNo" -->
       <span class="txt" style="margin-left:7%">采购订单：</span>
       <PurchOrderSearchInput ref="purchOrderInput"  @onConfirm="onSeletedOrder"
           :propertyObject="headerData" inputProperty="purchaseOrderNo"></PurchOrderSearchInput>
    </div> 
    <div class="item">
      <span class="txt">公司：</span>
      <el-input v-model="headerData.companyName" placeholder="暂无公司" :disabled="true"></el-input>
    </div>

    <div class="item">
      <span class="txt">供应商：</span>
      <el-input v-model="headerData.supplierName" placeholder="暂无客户" :disabled="true"></el-input>
    </div>
    <div class="item">
      <span class="txt">备注：</span>
      <el-input v-model="headerData.voucherHeaderTxt" placeholder="备注" ></el-input>
    </div>

    <div class="item">
      <span class="txt">凭证日期：</span>
      <el-date-picker v-model="headerData.voucherDate" type="date" placeholder="选择日期"></el-date-picker>
    </div>

    <div class="item">
      <span class="txt">过账日期：</span>
      <el-date-picker v-model="headerData.postingDate" type="date" placeholder="选择日期"></el-date-picker>
    </div>

    
  </div>
</template>

<script>
import cw_query_input from 'components/query/cw_query_input.vue'
import PurchOrderSearchInput  from 'busicomponent/busiform/purchaseorder/PurchOrderSearchInput.vue'
import {purchaseOrderApi} from 'api/PurchaseMngApi.js';

export default {
    components:{
       PurchOrderSearchInput
    },
    props:{
        inputProperty:{
           type:String,
            default:()=>{
                return 'header'
            }
        },
        propertyObject:{
            type:Object,
             default:()=>{
                return {
                    header:'header 中国加油'
                }
            }
        },
        headerProps:{
            type:Object,
            default:()=>{
               return {}
            }
        }
    },
    data(){
        return {
          //headerData:this.headerProps, 
          headerData:{
             voucherDate:new Date(),
             postingDate:new Date(),
             companyName:''
          } 
        }
    },
    methods:{
        onSeletedOrder(purchaseOrder){
          // debugger;
          console.log("-------------"+JSON.stringify(purchaseOrder));
          // console.log(this.$refs.purchOrderInput);
          //this.headerData.purchaseOrderNo=purchaseOrder.purchaseOrderNo;

          this.$set(this.headerData,'purchaseOrderNo',purchaseOrder.purchaseOrderNo);
          this.headerData= Object.assign({},this.headerData);
          
          this.loadPurchaseOrder(purchaseOrder.purchaseOrderId);

          this.$refs.purchOrderInput.closeSearchWindow();
        },
        /**
         * 加载采购订单
         */
        async loadPurchaseOrder(purchaseOrderId){
           if(purchaseOrderId){
              let {data} = await this.$get(purchaseOrderApi.loadPurchaseOrderUrl,{'purchaseOrderId':purchaseOrderId});
              // debugger;
              this.headerData.companyId=data.companyId;
              this.headerData.companyCode=data.companyCode;
              this.headerData.companyName=data.companyName;
 
              this.headerData.supplierId=data.supplierId;
              this.headerData.supplierCode=data.supplierCode;
              this.headerData.supplierName=data.supplierDesc;

              this.$emit("onOrderDetail",data.details);
              console.log(data);
          }
        }
    }
}
</script>

<style scoped>
    .el-input-group{
       width:75%   
    }
</style>